import { gsap } from "gsap";
import Swiper from 'swiper/bundle';


var swiper = new Swiper('.swiper-container', {
  loop: true,
  slidesPerView: 'auto',
  centeredSlides: true,
  navigation: {
    nextEl: '.swiper-button-next',
    prevEl: '.swiper-button-prev',
  },
  breakpoints: {
    // 画面幅が 640px 以上の場合（window width >= 640px）
    768: {
      allowTouchMove: false
    }
  }
});



document.addEventListener(
  "DOMContentLoaded",
  () => {
    let modalMaxHeight = document.querySelector(".modal__sec").clientHeight;
    let modalInner = document.querySelectorAll(".modal__blc");
    if(window.innerWidth > 768) {
      modalMaxHeight = modalMaxHeight - 200;
    }
    else {
      modalMaxHeight = modalMaxHeight - 40;
    }
    for(let i = 0; i < modalInner.length; i++) {
      var modalHeight = modalInner[i].clientHeight;
      if(modalHeight > modalMaxHeight) {
        modalInner[i].style.justifyContent = "flex-start";
      }
      else {
        modalInner[i].style.justifyContent = "center";
      }
    }
  },
  false
);

window.addEventListener(
  "scroll",
  () => {

    let element = document.querySelector(".products-main__blc");
    // windowの高さ - a
    let windowHeight = window.document.documentElement.clientHeight;

    // 現在のスクロール量
    let scrollTop =
        document.documentElement.scrollTop || document.body.scrollTop;
    // 画面左上から要素までの高さ - b
    let rect = element.getBoundingClientRect();
    let offset = rect.top + scrollTop;
    // 要素が画面に表示されるスクロール量(a - b)
    let scrollHeight = offset - windowHeight;

    var pin = document.querySelectorAll(".products-main__pin");
    // 画面の1/perNumを超えたら、classを追加
    if (scrollTop > scrollHeight + windowHeight / 5) {
      gsap.timeline()
        .to(pin, { opacity: 1, scale: 1.1, duration: .3, ease: "ease:Linear.easeNone" }, .5)
        .to(pin, { scale: 1, duration: .1, ease: "ease:Linear.easeNone"}, .79)
    }
  },
  false
);







var modal = document.querySelector(".products-modal__inner");
var elementPin = document.querySelectorAll(".products-main__pin");
for(let i = 0; i < elementPin.length; i++) {
  elementPin[i].addEventListener(
    "click",
    (e) => {
      swiper.slideTo(e.currentTarget.dataset.index);
      gsap
        .timeline({
          defaults: {
            ease: "power2.out",
          },
        })
        .to(modal, { zIndex: 2000, duration: 0.01 }, .2)
        .to(modal, { opacity: 1, duration: 0.6 }, .21);
        scrollLock();
    },
    false
  );
}



var elementItem = document.querySelectorAll(".products-choices__item");
for(let i = 0; i < elementItem.length; i++) {
  elementItem[i].addEventListener(
    "click",
    (e) => {
      swiper.slideTo(e.currentTarget.dataset.index);
      gsap
        .timeline({
          defaults: {
            ease: "power2.out",
          },
        })
        .to(modal, { zIndex: 2000, duration: 0.01 }, .2)
        .to(modal, { opacity: 1, duration: 0.6 }, .21);
        scrollLock();
    },
    false
  );
}


var modalBtn= document.querySelector(".products-modal__close")
modalBtn.addEventListener("click", function() {
  gsap
    .timeline({
      defaults: {
        ease: "power2.out",
      },
    })
    .to(modal, { opacity: 0, duration: 0.5 }, 0)
    .to(modal, { zIndex: -100, duration: 0.01 }, 0.51);
    scrollLock();
});

var modalWrapper = document.querySelector(".products-modal__blank");
modalWrapper.addEventListener("click", function() {
  document.querySelector(".products-modal__close").click();
});



let currentY;
function scrollLock() {
  if (document.body.classList.contains("is-scroll-locked")) {
    document.body.style.top = "";
    document.body.classList.remove("is-scroll-locked");
    window.scrollTo(0, currentY);
    return false;
  }

  currentY = document.documentElement.scrollTop || document.body.scrollTop;

  // メニューを開いたときにスクロール位置が一番上に戻らないように
  document.body.style.top = `-${currentY}px`;
  document.body.classList.add("is-scroll-locked");
}
